export class AuditLogConstants {
  public static readonly dateColumnsFormatExceptions: string[] = ['Followup'];
  public static readonly pipeFormatExceptions: string[] = ['Coverage'];
  public static readonly numberFormatExceptions: string[] = ['MarketCapitalization', 'AUM'];
}
